var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 635 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#3dcca8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.86,101.03l18.88-23.44h15.28l-17.92,21.44,18.88,31.36h-15.6l-13.12-22.64-6.4,7.76v14.88h-13.76v-52.8h13.76v23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.36,110.39c0,13.12-8.64,20.8-21.2,20.8s-21.12-7.68-21.12-20.8,8.64-20.8,21.12-20.8,21.2,7.68,21.2,20.8Zm-28.64,0c0,7.84,2.72,11.12,7.44,11.12s7.52-3.28,7.52-11.12-2.8-11.12-7.52-11.12-7.44,3.28-7.44,11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.76,90.38h12.16l.4,8.08c2.4-5.84,7.28-8.88,13.68-8.88,8.24,0,13.84,4.88,13.84,14.16v26.64h-13.6v-23.04c0-5.52-2.32-7.36-5.68-7.36-3.92,0-7.2,2.56-7.2,9.2v21.2h-13.6v-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7,100.07h-11.92v16.08c0,3.84,1.92,5.36,5.28,5.36,2.56,0,4.24-.64,5.84-1.76l1.44,8.4c-2.64,1.84-7.12,3.04-11.28,3.04-9.12,0-14.8-3.52-14.88-12.8v-18.32h-6.88v-9.68h6.88v-8.96l13.6-3.76v12.72h11.92v9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.84,110.39c0-13.2,8.56-20.8,20.96-20.8s19.84,7.92,19.84,18.96c0,2-.16,4-.32,5.28h-27.28c.8,5.6,3.76,7.76,8.4,7.76,4,0,6.32-1.68,7.52-4.56l10.88,3.6c-2.32,6.88-10,10.56-18.4,10.56-13.28,0-21.6-7.6-21.6-20.8Zm13.28-3.84h14.64c-.56-4.8-2.88-7.44-6.96-7.44s-6.8,2.32-7.68,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.28,90.38h12.16l.4,8.08c2.4-5.84,7.28-8.88,13.68-8.88,8.24,0,13.84,4.88,13.84,14.16v26.64h-13.6v-23.04c0-5.52-2.32-7.36-5.68-7.36-3.92,0-7.2,2.56-7.2,9.2v21.2h-13.6v-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.21,100.07h-11.92v16.08c0,3.84,1.92,5.36,5.28,5.36,2.56,0,4.24-.64,5.84-1.76l1.44,8.4c-2.64,1.84-7.12,3.04-11.28,3.04-9.12,0-14.8-3.52-14.88-12.8v-18.32h-6.88v-9.68h6.88v-8.96l13.6-3.76v12.72h11.92v9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M566.13,123.91c0,4.48-3.04,7.2-8,7.2s-8-2.72-8-7.2,3.04-7.28,8-7.28,8,2.72,8,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.13,98.95c-3.52,0-6.16,1.52-7.12,6l-11.52-2.72c1.44-7.68,7.84-12.64,19.44-12.64s18.48,5.28,18.48,15.2v14.64c0,2.16,.96,3.12,2.8,3.12,.88,0,1.68-.08,2.32-.32l-.8,7.76c-1.52,.72-3.44,1.12-5.84,1.12-5.04,0-8.88-1.92-10.16-6-2.24,4.08-7.6,6.08-13.04,6.08-8.24,0-13.44-3.84-13.44-11.04,0-5.76,3.36-9.6,10.8-11.12l13.84-2.88v-1.12c0-3.76-2.24-6.08-5.76-6.08Zm-1.12,23.44c3.6,0,6.88-2.08,6.88-6.8v-2.24l-6.48,1.36c-3.2,.64-4.72,1.76-4.72,4.16s1.92,3.52,4.32,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.82,79.26c0-4.56,2.4-6.56,7.92-6.56s7.92,2,7.92,6.56-2.4,6.48-7.92,6.48-7.92-2-7.92-6.48Zm14.72,51.12h-13.6v-40h13.6v40Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_4548",
    className: "cls-2",
    d: "M100,0C155.23,0,200,44.77,200,100s-44.77,100-100,100S0,155.23,0,100C0,44.77,44.77,0,100,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_4549",
    className: "cls-1",
    d: "M71.53,54.94v44.55c.01,.84-.59,1.57-1.42,1.71-5.69,1.14-27.04,3.99-27.04-14.23v-31.74c0-7.86,6.37-14.23,14.23-14.23s14.23,6.37,14.23,14.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4550",
    className: "cls-1",
    d: "M114.23,83.41v44.7c-.06,.79-.64,1.44-1.42,1.57-5.69,1.13-27.04,3.98-27.04-14.24v-31.74c0-7.86,6.37-14.23,14.23-14.23s14.23,6.37,14.23,14.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4551",
    className: "cls-1",
    d: "M156.94,111.88v44.7c-.06,.79-.64,1.44-1.42,1.57-5.69,1.13-27.04,3.98-27.04-14.24v-31.74c0-7.86,6.37-14.23,14.23-14.23s14.23,6.37,14.23,14.23"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKkLogo);
export default __webpack_public_path__ + "static/media/kk-logo.6698dcf5c85baa5ea90d33ae6e166991.svg";
export { ForwardRef as ReactComponent };